import { Button, Col, Divider, Form, Image, Input, Modal, Row, Typography, Upload } from "antd";
import { EyeOutlined } from '@ant-design/icons';
import useConfigurarRecibos from "./useConfigurarRecibos";
import { colInputs12, colInputs8 } from "./GridStyled";
import Loading from "../../../../components/Loading";
import { BiPencil } from "react-icons/bi";
import { urlImgEntidades } from "../../../../services/urls";
import ImgCrop from "antd-img-crop";
import { useContext } from "react";
import { ThemeContext } from "../../../../contexts/ThemeContext";

const { Title, Paragraph } = Typography;

export interface IPropsConfigRecibos {
    handleHabilitarAbasAposConfig: () => void;
}

const ConfigurarRecibos = ({ handleHabilitarAbasAposConfig }: IPropsConfigRecibos) => {

    const { theme } = useContext(ThemeContext);

    const {
        refForm,
        uploadButton,
        handleChange,
        beforeUpload,
        imageUrlAssinatura,
        imageUrlLogo,
        clickSubmitForm,
        isLoading,
        habilitarEdicao,
        dadosConfigRecibo,
        setHabilitarEdicao,
        buscaRecibos,

        isModalOpen,
        showModal,
        handleCancel,
        entity,
        handleChangeLogo,
        uploadButtonLogo
    } = useConfigurarRecibos({ handleHabilitarAbasAposConfig });

    return (
        <>
            <Loading loading={isLoading}>
                <Row>
                    <Col span={24}>
                        <Title level={3}>
                            Configurar dados do recibo
                        </Title>
                    </Col>
                    <Col>
                        <Button
                            type="dashed"
                            loading={isLoading}
                            onClick={showModal}
                            icon={<EyeOutlined />}
                            style={{
                                marginRight: 5
                            }}
                        >
                            Visualizar Recibo
                        </Button>
                        {
                            habilitarEdicao === false && (
                                <Button
                                    type="primary"
                                    loading={isLoading}
                                    onClick={() => setHabilitarEdicao(true)}
                                    icon={<BiPencil />}
                                    color='gold'
                                    variant='solid'
                                >
                                    Editar
                                </Button>
                            )
                        }
                    </Col>
                </Row>
                <Divider />
                <Form
                    ref={refForm}
                    name="formModalAddAssociacao"
                    layout="vertical"
                    initialValues={{
                        remember: true,
                    }}
                    onFinishFailed={() => { }}
                >
                    <Row>
                        <Col span={24} >
                            <Row>
                                <Col {...colInputs8} >
                                    <Form.Item
                                        name="municipio"
                                        label="Nome município ao lado da data"
                                        style={{ margin: 5 }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Por favor, preencha o nome do município.",
                                            }
                                        ]}
                                    >
                                        <Input disabled={dadosConfigRecibo ? !habilitarEdicao : false} placeholder="Umuarama - PR" />
                                    </Form.Item>
                                </Col>
                                <Col {...colInputs8}>
                                    <Paragraph>Imagem cabeçalho</Paragraph>
                                    <ImgCrop
                                        modalOk="Concluído"
                                        modalCancel="Cancelar"
                                        modalTitle="Editar"
                                        showGrid
                                        minAspect={0.3}
                                        maxAspect={4}
                                        aspectSlider
                                        aspect={1}
                                        maxZoom={5}
                                        showReset
                                        quality={1}

                                    >
                                        <Upload
                                            listType="picture-card"
                                            style={{
                                                width: 128,
                                                maxHeight: 128,
                                            }}
                                            showUploadList={false}
                                            action="/upload.do"
                                            beforeUpload={beforeUpload}
                                            onChange={handleChangeLogo}
                                            disabled={dadosConfigRecibo ? !habilitarEdicao : false}
                                        >
                                            {imageUrlLogo ?
                                                <img src={imageUrlLogo} alt="avatar" style={{ maxHeight: 100, maxWidth: 100 }} />
                                                : uploadButtonLogo()}
                                        </Upload>
                                    </ImgCrop>
                                    <p style={{ fontSize: 11, width: 108, textAlign: 'center', color: theme === 'dark' ? '#fff' : '#00000099' }}>
                                        Clique para adicionar uma foto
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24} style={{
                            marginLeft: 5,
                            marginTop: 15
                        }}>
                            <Title level={5}>
                                Assinatura
                            </Title>
                        </Col>
                        <Col {...colInputs8}>
                            <Form.Item
                                name="nome"
                                label="Nome da pessoa"
                                style={{ margin: 5 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor, preencha o nome.",
                                    }
                                ]}
                            >
                                <Input disabled={dadosConfigRecibo ? !habilitarEdicao : false} placeholder="Ex: João da Silva." />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs8}>
                            <Form.Item
                                name="cargo"
                                label="Cargo"
                                style={{ margin: 5 }}
                                rules={[
                                    {
                                        required: false,
                                        message: "Por favor, preencha o cargo.",
                                    }
                                ]}
                            >
                                <Input disabled={dadosConfigRecibo ? !habilitarEdicao : false} placeholder="Ex: Prefeito" />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs8}>
                            <Paragraph>Imagem de assinatura</Paragraph>
                            <ImgCrop
                                modalOk="Concluído"
                                modalCancel="Cancelar"
                                modalTitle="Editar"
                                showGrid
                                minAspect={0.3}
                                maxAspect={4}
                                aspectSlider
                                aspect={1}
                                maxZoom={5}
                                showReset
                                quality={1}

                            >
                                <Upload
                                    listType="picture-card"
                                    style={{
                                        width: 128,
                                        maxHeight: 128,
                                    }}
                                    showUploadList={false}
                                    action="/upload.do"
                                    beforeUpload={beforeUpload}
                                    onChange={handleChange}
                                    disabled={dadosConfigRecibo ? !habilitarEdicao : false}
                                >
                                    {imageUrlAssinatura ?
                                        <img src={imageUrlAssinatura} alt="avatar" style={{ maxHeight: 100, maxWidth: 100 }} />
                                        : uploadButton()}
                                </Upload>
                            </ImgCrop>
                            <p style={{ fontSize: 11, width: 108, textAlign: 'center', color: theme === 'dark' ? '#fff' : '#00000099' }}>
                                Clique para adicionar uma foto
                            </p>
                        </Col>
                        <Col {...colInputs12}>
                            <Form.Item
                                name="footer"
                                label="Rodapé do arquivo"
                                style={{ margin: 5 }}
                                rules={[
                                    {
                                        required: false,
                                        message: "Por favor, preencha o rodapé.",
                                    }
                                ]}
                            >
                                <Input.TextArea disabled={dadosConfigRecibo ? !habilitarEdicao : false} autoSize={{ minRows: 5 }} />
                            </Form.Item>
                        </Col>

                        <Col span={24} hidden={dadosConfigRecibo ? !habilitarEdicao : false} >
                            <Row style={{ marginTop: 10 }}>
                                <Col span={24} style={{ textAlign: "end", }}>
                                    <Button
                                        type="default"
                                        hidden={habilitarEdicao === undefined}
                                        loading={isLoading}
                                        onClick={() => {
                                            setHabilitarEdicao(false)
                                            buscaRecibos()
                                        }}
                                        style={{
                                            marginRight: 5
                                        }}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        type="primary"
                                        loading={isLoading}
                                        onClick={clickSubmitForm}
                                    >
                                        {
                                            dadosConfigRecibo && dadosConfigRecibo != null ?
                                                'Atualizar' :
                                                'Cadastrar'
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
                <Modal
                    title="Exemplo do Recibo"
                    open={isModalOpen}
                    onOk={handleCancel}
                    onCancel={handleCancel}
                    destroyOnClose
                    width={1000}
                >
                    <div style={{ width: '100%', padding: '40px 0', fontFamily: 'Arial, sans-serif', fontSize: 14, color: '#000' }}>
                        <div style={{ width: '100%' }}>

                            <div style={{ textAlign: 'start', marginBottom: 30, padding: '0 40px' }}>
                                {
                                    imageUrlLogo ? (
                                        <img
                                            src={`${imageUrlLogo}`}
                                            alt="logo"
                                            style={{ maxWidth: '25%', height: 'auto' }}
                                        />
                                    ) : (
                                        <img
                                            src={`${urlImgEntidades}/${entity?.entity?.logo_light}`}
                                            alt="logo"
                                            style={{ maxWidth: '25%', height: 'auto' }}
                                        />
                                    )
                                }
                            </div>

                            <div style={{ borderTop: '1px solid #000', margin: '20px 0' }} />

                            <div style={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold', marginBottom: 30 }}>RECIBO</div>
                            <div style={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold', marginBottom: 30 }}>
                                R$
                            </div>

                            <div style={{ marginBottom: 45, padding: '0 40px', fontSize: 14 }}>
                                <p><strong>Recebemos de:</strong> Prefeitura Municipal de </p>
                                <p><strong>A importância de:</strong> R$ </p>
                                <p><strong>Referente a:</strong> Contribuição para esta Federação em </p>
                            </div>

                            <p style={{ padding: '0 40px', fontSize: 14 }}>
                                Pelo que damos plena e total quitação da quantia recebida.
                            </p>

                            <div style={{ textAlign: 'right', fontSize: 14, marginTop: 80, marginBottom: 120, padding: '0 40px' }}>
                                {dadosConfigRecibo && dadosConfigRecibo.municipio}, ________/____________/_________
                            </div>


                            <div style={{ textAlign: 'center', margin: '60px 0', padding: '0 40px', fontSize: 14 }}>
                                {
                                    imageUrlAssinatura && (
                                        <img
                                            src={`${imageUrlAssinatura}`}
                                            alt="logo"
                                            style={{ maxWidth: '50%', height: 'auto', }}
                                        />
                                    )
                                }
                                <div style={{ borderTop: '1px solid #000', width: 300, margin: '0 auto 5px' }} />
                                <div>
                                    {dadosConfigRecibo && dadosConfigRecibo.nome}
                                    <br />
                                    {dadosConfigRecibo && dadosConfigRecibo.cargo}
                                </div>
                            </div>

                            <div style={{ textAlign: 'right', padding: '0 40px', fontSize: 14 }}>
                                <div style={{ borderTop: '1px solid #000', margin: '20px 0' }} />
                                {/* {(dadosConfigRecibo && dadosConfigRecibo?.footer )&& dadosConfigRecibo.footer.split('\n').map((linha, index) => (
                                    <p key={index}>{linha}<br /></p>
                                ))} */}
                                {
                                    dadosConfigRecibo?.footer &&
                                    <div
                                        dangerouslySetInnerHTML={{ __html: dadosConfigRecibo?.footer?.replace(/\n/g, '<br />'), }}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </Modal>
            </Loading>
        </>
    )
}

export default ConfigurarRecibos;
